export enum IntercomEvents {
  ShowArticle = 'ShowArticle',
  ShowNewMessage = 'ShowNewMessage',
}
